// Loads `@/lib/logger` at call time so callers add no static edge to it: safeLocalStorage would
// otherwise close an import cycle, and the /mcp-connect entry would ship Sentry. A failed chunk
// fetch is swallowed — there is nothing left to log it with.

export function warnViaLogger(message: string, error?: unknown): void {
  void import('@/lib/logger').then(({ logger }) => logger.warn(message, error)).catch(() => {})
}

export function errorViaLoggerToSentry(message: string): void {
  void import('@/lib/logger').then(({ logger }) => logger.error(message, undefined, true)).catch(() => {})
}

export function infoViaLogger(...args: unknown[]): void {
  void import('@/lib/logger').then(({ logger }) => logger.info(...args)).catch(() => {})
}
